<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {CRUISE, PRODUCT_NAME} from '@/utils/cruises/cruises-const'

    @Component
    export class CruisesStoreMixin extends Vue {
        get productStore() {
            return cruisesStore
        }

        get productRuntimeStore() {
            return cruisesRuntimeStore
        }

        get productType() {
            return CRUISE
        }

        get productName() {
            return PRODUCT_NAME
        }
    }

    export default CruisesStoreMixin
</script>
